
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $7ac79f3df4a40e17$exports = {};

$parcel$export($7ac79f3df4a40e17$exports, "add-span-handle", () => $7ac79f3df4a40e17$export$d11f56a767a45c14, (v) => $7ac79f3df4a40e17$export$d11f56a767a45c14 = v);
$parcel$export($7ac79f3df4a40e17$exports, "bottom-handle", () => $7ac79f3df4a40e17$export$2bc7b7931566173a, (v) => $7ac79f3df4a40e17$export$2bc7b7931566173a = v);
$parcel$export($7ac79f3df4a40e17$exports, "bp5-editable-text", () => $7ac79f3df4a40e17$export$73efc554e1c6c2f6, (v) => $7ac79f3df4a40e17$export$73efc554e1c6c2f6 = v);
$parcel$export($7ac79f3df4a40e17$exports, "col-note-label", () => $7ac79f3df4a40e17$export$9fcfa573a0fb16ad, (v) => $7ac79f3df4a40e17$export$9fcfa573a0fb16ad = v);
$parcel$export($7ac79f3df4a40e17$exports, "column-notes", () => $7ac79f3df4a40e17$export$65eeec090007662b, (v) => $7ac79f3df4a40e17$export$65eeec090007662b = v);
$parcel$export($7ac79f3df4a40e17$exports, "focusable", () => $7ac79f3df4a40e17$export$ecc6d1fcdff4f700, (v) => $7ac79f3df4a40e17$export$ecc6d1fcdff4f700 = v);
$parcel$export($7ac79f3df4a40e17$exports, "handle", () => $7ac79f3df4a40e17$export$8f34ce051745d39e, (v) => $7ac79f3df4a40e17$export$8f34ce051745d39e = v);
$parcel$export($7ac79f3df4a40e17$exports, "height-range", () => $7ac79f3df4a40e17$export$bd5f2960da12add0, (v) => $7ac79f3df4a40e17$export$bd5f2960da12add0 = v);
$parcel$export($7ac79f3df4a40e17$exports, "link", () => $7ac79f3df4a40e17$export$9c30223ca0a664fb, (v) => $7ac79f3df4a40e17$export$9c30223ca0a664fb = v);
$parcel$export($7ac79f3df4a40e17$exports, "new-note", () => $7ac79f3df4a40e17$export$3c68e5ffc088ca75, (v) => $7ac79f3df4a40e17$export$3c68e5ffc088ca75 = v);
$parcel$export($7ac79f3df4a40e17$exports, "note", () => $7ac79f3df4a40e17$export$a92e4c44d367d0af, (v) => $7ac79f3df4a40e17$export$a92e4c44d367d0af = v);
$parcel$export($7ac79f3df4a40e17$exports, "note-connector", () => $7ac79f3df4a40e17$export$d3f89f34ec8b4e37, (v) => $7ac79f3df4a40e17$export$d3f89f34ec8b4e37 = v);
$parcel$export($7ac79f3df4a40e17$exports, "note-editor", () => $7ac79f3df4a40e17$export$96e4d781021e47d7, (v) => $7ac79f3df4a40e17$export$96e4d781021e47d7 = v);
$parcel$export($7ac79f3df4a40e17$exports, "note-inner", () => $7ac79f3df4a40e17$export$3c4003d81cbed2b2, (v) => $7ac79f3df4a40e17$export$3c4003d81cbed2b2 = v);
$parcel$export($7ac79f3df4a40e17$exports, "notes-list", () => $7ac79f3df4a40e17$export$3f8951a76c9c5f89, (v) => $7ac79f3df4a40e17$export$3f8951a76c9c5f89 = v);
$parcel$export($7ac79f3df4a40e17$exports, "position-editor", () => $7ac79f3df4a40e17$export$788e679f3189565f, (v) => $7ac79f3df4a40e17$export$788e679f3189565f = v);
$parcel$export($7ac79f3df4a40e17$exports, "top-handle", () => $7ac79f3df4a40e17$export$a16d380cfbbc262f, (v) => $7ac79f3df4a40e17$export$a16d380cfbbc262f = v);
$parcel$export($7ac79f3df4a40e17$exports, "underlay", () => $7ac79f3df4a40e17$export$c2b29aa2c10a1ad2, (v) => $7ac79f3df4a40e17$export$c2b29aa2c10a1ad2 = v);
var $7ac79f3df4a40e17$export$d11f56a767a45c14;
var $7ac79f3df4a40e17$export$2bc7b7931566173a;
var $7ac79f3df4a40e17$export$73efc554e1c6c2f6;
var $7ac79f3df4a40e17$export$9fcfa573a0fb16ad;
var $7ac79f3df4a40e17$export$65eeec090007662b;
var $7ac79f3df4a40e17$export$ecc6d1fcdff4f700;
var $7ac79f3df4a40e17$export$8f34ce051745d39e;
var $7ac79f3df4a40e17$export$bd5f2960da12add0;
var $7ac79f3df4a40e17$export$9c30223ca0a664fb;
var $7ac79f3df4a40e17$export$3c68e5ffc088ca75;
var $7ac79f3df4a40e17$export$a92e4c44d367d0af;
var $7ac79f3df4a40e17$export$d3f89f34ec8b4e37;
var $7ac79f3df4a40e17$export$96e4d781021e47d7;
var $7ac79f3df4a40e17$export$3c4003d81cbed2b2;
var $7ac79f3df4a40e17$export$3f8951a76c9c5f89;
var $7ac79f3df4a40e17$export$788e679f3189565f;
var $7ac79f3df4a40e17$export$a16d380cfbbc262f;
var $7ac79f3df4a40e17$export$c2b29aa2c10a1ad2;
$7ac79f3df4a40e17$export$d11f56a767a45c14 = `obWsAG_add-span-handle`;
$7ac79f3df4a40e17$export$2bc7b7931566173a = `obWsAG_bottom-handle`;
$7ac79f3df4a40e17$export$73efc554e1c6c2f6 = `obWsAG_bp5-editable-text`;
$7ac79f3df4a40e17$export$9fcfa573a0fb16ad = `obWsAG_col-note-label`;
$7ac79f3df4a40e17$export$65eeec090007662b = `obWsAG_column-notes`;
$7ac79f3df4a40e17$export$ecc6d1fcdff4f700 = `obWsAG_focusable`;
$7ac79f3df4a40e17$export$8f34ce051745d39e = `obWsAG_handle`;
$7ac79f3df4a40e17$export$bd5f2960da12add0 = `obWsAG_height-range`;
$7ac79f3df4a40e17$export$9c30223ca0a664fb = `obWsAG_link`;
$7ac79f3df4a40e17$export$3c68e5ffc088ca75 = `obWsAG_new-note`;
$7ac79f3df4a40e17$export$a92e4c44d367d0af = `obWsAG_note`;
$7ac79f3df4a40e17$export$d3f89f34ec8b4e37 = `obWsAG_note-connector`;
$7ac79f3df4a40e17$export$96e4d781021e47d7 = `obWsAG_note-editor`;
$7ac79f3df4a40e17$export$3c4003d81cbed2b2 = `obWsAG_note-inner`;
$7ac79f3df4a40e17$export$3f8951a76c9c5f89 = `obWsAG_notes-list`;
$7ac79f3df4a40e17$export$788e679f3189565f = `obWsAG_position-editor`;
$7ac79f3df4a40e17$export$a16d380cfbbc262f = `obWsAG_top-handle`;
$7ac79f3df4a40e17$export$c2b29aa2c10a1ad2 = `obWsAG_underlay`;


export {$7ac79f3df4a40e17$exports as default};
//# sourceMappingURL=column-components.061d65b5.js.map
